<template>
  <div class="item">
    <div class="img-content">
      <div
        class="img-circle"
        :style="{
          backgroundImage: 'url(' + file(item.pressclipping_imagelink) + ')',
        }"
      ></div>
    </div>
    <div class="press-item-body">
      <h1 class="title">
        <router-link
          tag="span"
          :to="`/${lng}/press/${$route.params.type}/${$route.params.fromTo}/${item.pressclipping_id}`"
          >{{ item.key }}</router-link
        >
        <span></span>
      </h1>
      <div class="press-text" v-html="imageFixingUrl(item.body)"></div>
      <div class="gallery-content" v-if="$route.params.type !== 'print_publications'">
        <!-- show gallery button -->
        <button class="gallery-button" @click="$emit('start-gallery', item)">
          {{ t.press.viewGallery }}
        </button>
      </div>
      <!-- IF publication -->
      <div v-if="$route.params.type !== 'print_publications'" class="press-info-content">
        <ul>
          <li>
            <strong>{{ t.press.pressName }}</strong> :
            <span>{{ item.pressclipping_name }}</span>
          </li>
          <li>
            <strong>{{ t.press.pressDate }}</strong> :
            <span>{{ fixDate(item.pressclipping_date) }}</span>
          </li>
        </ul>
      </div>
      <router-link
        tag="span"
        v-if="$route.params.id"
        class="back-to"
        :to="`/${$route.params.lang}/press/${$route.params.type}/${$route.params.fromTo}`"
        >{{ t.back }}</router-link
      >
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  props: {
    item: Object,
  },
  computed: {
    ...mapGetters([
      "t",
      "lng",
      "file",
      "press_list",
      "press_extra_images",
      "imageFixingUrl",
    ]),
  },
  methods: {
    fixDate(date) {
      date = new Date(date);
      let dd = date.getDate();
      let mm = date.getMonth() + 1;

      dd = dd < 10 ? "0" + dd : dd;
      mm = mm < 10 ? "0" + mm : mm;

      return `${dd} - ${mm} - ${date.getFullYear()}`;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../styles/colors";
.item {
  padding-bottom: 30px;
  padding-top: 20px;
  width: 100%;
  display: flex;
  flex-direction: row;
  .img-content {
    padding: 15px 50px 15px 30px;
    .img-circle {
      width: 135px;
      height: 135px;
      overflow: hidden;
      background-color: #ccc;
      border-radius: 50%;
      background-size: cover;
      background-position: top;
      box-shadow: 0 3px 10px rgba(0, 0, 0, 0.25);
    }
  }

  @media screen and (max-width: 580px) {
    flex-direction: column;
  }
  &:not(:last-child) {
    border-bottom: 1px solid #ccc;
  }
  .press-item-body {
    h1.title {
      font-size: 15px;
      color: $main;
      font-weight: normal;
      line-height: 24px;
      position: relative;
      span {
        cursor: pointer;
        &:hover {
          color: $mainLight;
          &:after {
            position: absolute;
            right: 100%;
            top: 0;
            content: "\2022";
            margin-right: 7px;
          }
        }
      }
    }

    .press-info-content {
      color: #737375;
      font-size: 15px;
      li {
        margin-bottom: 10px;
      }
      strong {
        font-weight: normal;
        color: $main;
      }
    }
  }
  .gallery-content {
    margin: 20px 0;
  }
  .press-publication {
    table {
      background: #000;
    }
  }
}
</style>
